type Props = {
    isActive: boolean
    onClick?: any
}

const BannerViewIconMobile = ({ isActive, onClick }: Props) => {
    return (
        <svg
            width="20"
            height="16"
            viewBox="0 0 20 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ cursor: 'pointer' }}
            onClick={onClick && onClick}
        >
            <path
                opacity="1"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.33333 14.105C3.33333 15.0637 3.33333 15.73 2.35 15.73H0.983333C0 15.73 0 15.0637 0 14.105C0 13.1463 0 12.48 0.983333 12.48H2.33333C3.31667 12.48 3.31667 13.1463 3.31667 14.105H3.33333ZM7.65008 3.25H19.0001C19.9834 3.25 19.9834 2.58375 19.9834 1.625C19.9834 0.66625 19.9834 0 19.0001 0H7.65008C6.66675 0 6.66675 0.66625 6.66675 1.625C6.66675 2.58375 6.66675 3.25 7.65008 3.25V3.25ZM2.35 6.17494H0.983333C0 6.17494 0 6.84119 0 7.79994C0 8.75869 0 9.42494 0.983333 9.42494H2.33333C3.31667 9.42494 3.31667 8.75869 3.31667 7.79994C3.31667 6.84119 3.31667 6.17494 2.33333 6.17494H2.35ZM2.35 0H0.983333C0 0 0 0.66625 0 1.625C0 2.58375 0 3.25 0.983333 3.25H2.33333C3.31667 3.25 3.31667 2.58375 3.31667 1.625C3.31667 0.66625 3.31667 0 2.33333 0H2.35ZM19.0167 6.10437H7.65C6.66667 6.10437 6.66667 6.77062 6.66667 7.72937C6.66667 8.68813 6.66667 9.35438 7.65 9.35438H19C19.9833 9.35438 19.9833 8.68813 19.9833 7.72937C19.9833 6.77062 19.9833 6.10437 19 6.10437H19.0167ZM19.0167 12.48H7.65008C6.66675 12.48 6.66675 13.1463 6.66675 14.105C6.66675 15.0637 6.66675 15.73 7.65008 15.73H19.0001C19.9834 15.73 19.9834 15.0637 19.9834 14.105C19.9834 13.1463 19.9834 12.48 19.0001 12.48H19.0167Z"
                fill={`${isActive ? '#80C2C4' : '#B3DBDC'}`}
            />
        </svg>
    )
}

export default BannerViewIconMobile
